import { render } from "./TambahCukaiDialog.vue?vue&type=template&id=f171f892"
import script from "./TambahCukaiDialog.vue?vue&type=script&lang=js"
export * from "./TambahCukaiDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__